import { defineAxisId } from './define-axis-id.js';
import type { ChartUnit } from '../../../core/types/chart-unit.js';
import type { ValueRepresentation } from '../../../core/types/scales.js';
import type { MappedPositionedAxes, YAxisProps } from '../types/slots.js';

export const buildYAxisProps = (
  index: number,
  unit: ChartUnit,
  axesConfig: MappedPositionedAxes,
  valueRepresentation?: ValueRepresentation,
): YAxisProps => {
  const position =
    valueRepresentation === 'relative' || index % 2 === 0 ? 'left' : 'right';
  const axisConfig = axesConfig[position];
  return {
    ...axisConfig,
    type: axisConfig?.type ?? 'numerical',
    position,
    id: defineAxisId(unit),
    unit,
    valueRepresentation,
  };
};
